var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('w-file-drop',{attrs:{"max-file-size":_vm.$consts.MAX_FILE_SIZE.DEMAND,"accept":_vm.accept},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }